//SettingsModal.js
import React, { useState,useEffect } from 'react';
import { Keypair } from '@solana/web3.js';

function SettingsModal({ isOpen, onClose, activeWalletName }) {

// Steit dlja hranenija dannih
const [privateKey, setPrivateKey] = useState('');
const [walletAddress, setWalletAddress] = useState('');
const [walletName, setWalletName] = useState('');
const [traderAddress, setTraderAddress] = useState('');
const [solanaNetwork, setSolanaNetwork] = useState('mainnet-beta');
const [buyAmountEnabled, setBuyAmountEnabled] = useState(false);
const [buyAmount, setBuyAmount] = useState('');
const [buyAllEnabled, setBuyAllEnabled] = useState(false);
const [reserveAmount, setReserveAmount] = useState('');
const [antiMevBuy, setAntiMevBuy] = useState(false);
const [buyTimes, setBuyTimes] = useState(0);
const [slippage, setSlippage] = useState('');
const [liquidity, setLiquidity] = useState('');
const [priorityFee, setPriorityFee] = useState('');
const [bribe, setBribe] = useState('');
const [maxTax, setMaxTax] = useState('');
const [minVolume24h, setMinVolume24h] = useState("");
const [enableTakeProfit, setEnableTakeProfit] = useState(false);
const [takeProfitPercent, setTakeProfitPercent] = useState('');
const [enableStopLoss, setEnableStopLoss] = useState('');
const [stopLossPercent, setStopLossPercent] = useState('');
const [enableTrailingStop, setEnableTrailingStop] = useState(false);
const [trailingStopPercent, setTrailingStopPercent] = useState('');
const [autoSell, setAutoSell] = useState(false);
const [copySell, setCopySell] = useState(false);
const [sellPriorityFee, setSellPriorityFee] = useState('');
const [sellBribe, setSellBribe] = useState('');
const [sellSlippage, setSellSlippage] = useState('');
const [maxSellTax, setMaxSellTax] = useState('');
const [antiMevSell, setAntiMevSell] = useState(false);
const [honeypotCheck, setHoneypotCheck] = useState(false);
const [honeypotMode, setHoneypotMode] = useState("");
const [freezeCheck, setFreezeCheck] = useState(false);
const [manualEnabled, setManualEnabled] = useState(false);


useEffect(() => {
  if (!isOpen || activeWalletName) return;
  fetch(`/api/wallets/settings/${walletName}`)
    .then(res => {
      if (!res.ok) {
        throw new Error('Ошибка загрузки кошелька');
      }
      return res.json();
    })
    .then(data => {
      setWalletName(data.walletName ?? '');
      setTraderAddress(data.settings?.traderAddress ?? '');
      setSolanaNetwork(data.settings?.solanaNetwork ?? 'mainnet-beta');
      setHoneypotCheck(!!data.settings?.honeypotCheck);
      setHoneypotMode(data.settings?.honeypotMode ?? "");
      setFreezeCheck(!!data.settings?.freezeCheck);
      setManualEnabled(!!data.settings?.manualEnabled);
      setBuyAllEnabled(!!data.settings?.buyAllEnabled);
      setBuyAmountEnabled(data.settings?.buyAmount != null);
      setBuyAmount(data.settings?.buyAmount ?? '');
      setReserveAmount(data.settings?.reserveAmount ?? '');
      setBuyTimes(data.settings?.buyTimes ?? 0);
      setSlippage(data.settings?.slippage ?? '');
      setLiquidity(data.settings?.liquidity ?? '');
      setPriorityFee(data.settings?.priorityFeeUsd ?? '');
      setBribe(data.settings?.bribe ?? '');
      setMaxTax(data.settings?.maxTax ?? '');
      setMinVolume24h(data.settings?.minVolume24h ?? '');
      setAntiMevBuy(!!data.settings?.antiMevBuy);
      setAutoSell(!!data.settings?.autoSell);
      setCopySell(!!data.settings?.copySell);
      setEnableTakeProfit(!!data.settings?.enableTakeProfit);
      setTakeProfitPercent(data.settings?.takeProfitPercent ?? '');
      setEnableStopLoss(!!data.settings?.enableStopLoss);
      setStopLossPercent(data.settings?.stopLossPercent ?? '');
      setEnableTrailingStop(!!data.settings?.trailingStop?.enabled);
      setTrailingStopPercent(data.settings?.trailingStop?.percent ?? '');
      setSellPriorityFee(data.settings?.sellPriorityFee ?? '');
      setSellBribe(data.settings?.sellBribe ?? '');
      setSellSlippage(data.settings?.sellSlippage ?? '');
      setMaxSellTax(data.settings?.maxSellTax ?? '');
      setAntiMevSell(!!data.settings?.antiMevSell);
    })
    .catch(err => {
      console.error('Ошибка загрузки settings:', err);
    });

}, [isOpen, walletName]);



useEffect(() => {
  if (!isOpen) return;
  if (!activeWalletName) return;

  fetch(`/api-auth/api/wallet-full/${activeWalletName}`, {
    credentials: 'include'
  })
    .then(res => {
      if (!res.ok) throw new Error('Ошибка загрузки кошелька');
      return res.json();
    })
    .then(data => {
      setWalletName(data.walletName ?? '');
      setWalletAddress(data.walletAddress);
      setTraderAddress(data.settings?.traderAddress ?? '');
      setSolanaNetwork(data.settings?.solanaNetwork ?? 'mainnet-beta');
      setHoneypotCheck(!!data.settings?.honeypotCheck);
      setHoneypotMode(data.settings?.honeypotMode ?? "");
      setFreezeCheck(!!data.settings?.freezeCheck);
      setManualEnabled(!!data.settings?.manualEnabled);
      setBuyAllEnabled(!!data.settings?.buyAllEnabled);
      setBuyAmountEnabled(data.settings?.buyAmount != null);
      setBuyAmount(data.settings?.buyAmount ?? '');
      setReserveAmount(data.settings?.reserveAmount ?? '');
      setBuyTimes(data.settings?.buyTimes ?? 0);
      setSlippage(data.settings?.slippage ?? '');
      setLiquidity(data.settings?.liquidity ?? '');
      setPriorityFee(data.settings?.priorityFeeUsd ?? '');
      setBribe(data.settings?.bribe ?? '');
      setMaxTax(data.settings?.maxTax ?? '');
      setMinVolume24h(data.settings?.minVolume24h ?? '');
      setAntiMevBuy(!!data.settings?.antiMevBuy);
      setAutoSell(!!data.settings?.autoSell);
      setCopySell(!!data.settings?.copySell);
      setEnableTakeProfit(!!data.settings?.enableTakeProfit);
      setTakeProfitPercent(data.settings?.takeProfitPercent ?? '');
      setEnableStopLoss(!!data.settings?.enableStopLoss);
      setStopLossPercent(data.settings?.stopLossPercent ?? '');
      setEnableTrailingStop(!!data.settings?.trailingStop?.enabled);
      setTrailingStopPercent(data.settings?.trailingStop?.percent ?? '');
      setSellPriorityFee(data.settings?.sellPriorityFee ?? '');
      setSellBribe(data.settings?.sellBribe ?? '');
      setSellSlippage(data.settings?.sellSlippage ?? '');
      setMaxSellTax(data.settings?.maxSellTax ?? '');
      setAntiMevSell(!!data.settings?.antiMevSell);
    })
    .catch(err => {
      console.error('Ошибка загрузки settings:', err);
    });

}, [isOpen, activeWalletName]);



const handlePrivateKeyChange = (e) => {
  const value = e.target.value.trim();
  setPrivateKey(value);

  try {
    const secret = JSON.parse(value);
    const keypair = Keypair.fromSecretKey(new Uint8Array(secret));
    setWalletAddress(keypair.publicKey.toBase58());
  } catch (error) {
    setWalletAddress('');
  }
};

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
    >

      <div
        style={{
          backgroundColor: '#192033',
          padding: '30px',
          borderRadius: '12px',
          width: '40%',
          color: '#d1d5ab',
          position: 'relative',
          maxHeight: '80vh',
          overflowY: 'auto',
          boxSizing: 'border-box',

        }}
      >

        <h2 style={{ fontSize: '20px', marginBottom: '20px' }}>Settings</h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px' }}>Wallet Name</label>
            <input
              type="text"
              placeholder="Naprimer: Osnovnoj"
              value={walletName}
              onChange={(e) => setWalletName(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab'
              }}
            />
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '6px' }}> Private Key (Solana)</label> 
            <textarea
              placeholder="Vstavitj privatnij kljuch (JSON-massiv)"
              rows="3"
              value={privateKey}
              onChange={handlePrivateKeyChange}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab',
                resize: 'vertical'
              }}
            />
            {walletAddress && (
              <div style={{ marginTop:'10px', color: '#9ca3af' }}>
                   Adres koselka: <span style={{ fontFamily: 'monospace' }}>{walletAddress}</span>
              </div>
            )}
            </div>


          <div style={{ marginTop: '20px' }}>
            <label style={{ display: 'block', marginBottom: '6px' }}>Manual Mode</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <input
                type="checkbox"
                checked={manualEnabled}
                onChange={(e) => setManualEnabled(e.target.checked)}
              />
              <span style={{ color: '#9ca3af' }}>
                Manual on/off
              </span>
            </div>
          </div>


  {/* Kosheljok treidera*/}
          <div>
            <label style={{ display: 'block', marginTop: '20px', marginBottom: '6px' }}>Trader Wallet</label>
            <input
              type="text"
              placeholder="Adres treidera (Solana)"
              value={traderAddress}
              onChange={(e) => setTraderAddress(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab'
              }}
            />
          </div>

  {/* Setj Solana */}
          <div>
            <label style={{ display: 'block', marginTop: '20px', marginBottom: '6px' }}>Solana Network</label>
            <select
              value={solanaNetwork}
              onChange={(e) => setSolanaNetwork(e.target.value)}
              style={{
                width: '70%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab'
              }}
            >
              <option value="mainnet-beta">mainnet-beta</option>
              <option value="devnet">devnet</option>
              <option value="testnet">testnet</option>
            </select>
          </div>

  {/* Blok BUY */}
          <div>
            <h3 style={{ fontSize: '18px', marginTop: '30px', marginBottom: '10px', }}>BUY</h3>
          <div>
            <label style={{ display: 'block', marginBottom: '6px' }}>Add All DEX</label>
            <div style={{
              backgroundColor: '#111827',
              color: '#d1d5ab',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              Jupiter, Dexscreener, Raydium, Orca, Saber
            </div>
          </div>
        </div>


  {/* Honeypot Check */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Honey Pot</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={honeypotCheck}
              onChange={(e) => setHoneypotCheck(e.target.checked)}
            />
            <span style={{ color: '#9ca3af' }}>
              Proverjatj pered pokupkoj mozhno li prodavatj (anti-honeypot)
            </span>
          </div>
        </div>
  {/* Rezhim raboti honeypot */}
        {honeypotCheck && (
          <div style={{ marginTop: '10px' }}>
            <label style={{ display: 'block', marginBottom: '6px' }}>Honeypot Mode</label>
            <select
              value={honeypotMode}
              onChange={(e) => setHoneypotMode(e.target.value)}
              style={{
                width: '50%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab'
              }}
            >
              <option value="FAST">FAST 1 time</option>
              <option value="SAFE">SAFE 1 + 3h</option>
            </select>
            <span style={{ fontSize: '12px', color: '#6b7280', display: 'block', marginTop: '6px' }}>
              FAST = tolko pered vhodom | SAFE = pered vhodom i povtornimi vhozdam bolee 3h
            </span>
          </div>
        )}


  {/* Freeze Authority Check */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Freeze Authority</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={freezeCheck}
              onChange={(e) => setFreezeCheck(e.target.checked)}
            />
            <span style={{ color: '#9ca3af' }}>
              Proverjatj nalichie freeze authority u tokena
            </span>
          </div>
        </div>


  {/* Buy ALL */}
       <div style={{ marginTop: '20px' }}>
         <label style={{ display: 'block', marginBottom:'6px' }}>
           Buy All (Ispolzovatj vsju summu na koshelke)
         </label>
         <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
           <input
             type="checkbox"
             checked={buyAllEnabled}
             onChange={(e) => setBuyAllEnabled(e.target.checked)}
          />
          <span style={{ color: '#9ca3af' }}>
            Pokupaem na takuju ze summu kak u treidera (krome rezerva)
          </span>
        </div>
      </div>


  {/* Buy Amount */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>
            SOLL - Buy Amount - SOLL (razresheno tratitj)
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={buyAmountEnabled}
              onChange={(e) => setBuyAmountEnabled(e.target.checked)}
            />
            <input
              type="text" inputMode="decimal"
              placeholder="0.1"
              disabled={!buyAmountEnabled}
              value={buyAmount}
              onChange={(e) => setBuyAmount(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab'
              }}
            />
          </div>
        </div>

  {/* Buy Reserve Amount */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>SOLL - Reserve Amount (Solana)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="0.01"
            value={reserveAmount}
            onChange={(e) => setReserveAmount(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab'
          }}
        />
        <span style={{ fontSize: '12px', color: '#6b7280' }}>
          Eta summa dlja tax, bribe i drugih rashodov.
        </span>
      </div>

  {/* Buy Times */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Buy Times (kol-vo pokupok)</label>
          <select
            value={buyTimes}
            onChange={(e) => setBuyTimes(Number(e.target.value))}
            style={{
              width: '70%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          >
            {[0, 1, 2, 3, 4, 5].map((num) => (
              <option key={num} value={num}>{num === 0 ? '0 (bez ogranicenij)' : num}</option>
            ))}
          </select>
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Kolicestvo zahodov v zdelku.
          </span>
        </div>

  {/* Buy Slippage */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Slippage (%)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="1"
            value={slippage}
            onChange={(e) => setSlippage(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab'
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Dopustimoe otklonenie ceni %
          </span>
        </div>


  {/* Liquidity */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Liquidity ($)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="5000"
            value={liquidity}
            onChange={(e) => setLiquidity(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Minimalnaja likvidnostj dlja pokupki $.
          </span>
        </div>

  {/* Buy Priority Fee */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Priority Fee ($)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="0.01"
            value={priorityFee}
            onChange={(e) => setPriorityFee(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Dopolnitelnij fee uvelichenie skorosti.
          </span>
        </div>

  {/* Buy Vzjatka */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Vzjatka ($)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="0.01"
            value={bribe}
            onChange={(e) => setBribe(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }} 
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            plata dlja uvelicenija prioriteta tranzakcii.
          </span>
        </div>

  {/* Buy Max Tax */}
        <div style ={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Max Tax (%)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="10"
            value={maxTax}
            onChange={(e) => setMaxTax(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Maksimalnij razreshonnij nalog pokupki tokena.
          </span>
        </div>


  {/* Min Volume 24h */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Min Volume 24h ($)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="5000"
            value={minVolume24h}
            onChange={(e) => setMinVolume24h(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Minimalnij objom torgov za 24h dlja bezopasnogo vhoda
          </span>
        </div>


  {/* Buy Anti-Mev */}

        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Anti-MEV (pokupka)</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <input
            type="checkbox"
            checked={antiMevBuy}
            onChange={(e) => setAntiMevBuy(e.target.checked)}
          />
          <span style={{ color: '#9ca3af' }}>
            Vkljucitj zaschitu ot MEV-atak
          </span>
        </div>
      </div>

  {/* Auto Sell */} 
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Auto Sell</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={autoSell}
              onChange={(e) => setAutoSell(e.target.checked)}
            />
            <span style={{ color: '#9ca3af' }}>
              Avtoprodaza nastroiki treidera i moi
            </span>
          </div>
        </div>



  {/* Copy Sell */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Copy Sell</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={copySell}
              onChange={(e) => setCopySell(e.target.checked)}
            />
            <span style={{ color: '#9ca3af' }}>
              Kopirovatj prodazhu treidera
            </span>
          </div>
        </div>


  {/* SELL Take Profit */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Take Profit (%)</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={enableTakeProfit}
              onChange={(e) => setEnableTakeProfit(e.target.checked)}
            />
            <input
              type="text" inputMode="decimal"
              placeholder="30"
              disabled={!enableTakeProfit}
              value={takeProfitPercent}
              onChange={(e) => setTakeProfitPercent(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab',
              }}
            />
          </div>
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Fiksacija pribili procent
          </span>
        </div>

  {/* SELL Stop Loss */}
        <div style={{marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Stop Loss (%)</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={enableStopLoss}
              onChange={(e) => setEnableStopLoss(e.target.checked)}
            />
            <input
              type="text" inputMode="decimal"
              placeholder="20"
              disabled={!enableStopLoss}
              value={stopLossPercent}
              onChange={(e) => setStopLossPercent(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab',
              }}
            />
          </div>
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Avtoprodaza esli cena upala na procent
          </span>
        </div>

  {/* Sell Trailing Stop Loss */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Trailing Stop Loss (%)</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={enableTrailingStop}
              onChange={(e) => setEnableTrailingStop(e.target.checked)}
            />
            <input
              type="text" inputMode="decimal"
              placeholder="10"
              disabled={!enableTrailingStop}
              value={trailingStopPercent}
              onChange={(e) => setTrailingStopPercent(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '8px',
                border: '1px solid #374151',
                backgroundColor: '#111827',
                color: '#d1d5ab',
              }}
            />
          </div>
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Stop dvizetsja tolko vveth za cenoi, fiksiruetsja esli padaet na ukazannij %
          </span>
        </div>

 
  {/* Sell Priority Fee */}
        <div style={{marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}> Sell Priority Fee ($)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="0.01"
            value={sellPriorityFee}
            onChange={(e) => setSellPriorityFee(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }} 
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Dopolnitelnij fee dlja uskorenija obrabotki prodazi
          </span>
        </div>

  {/* Sell Bribe */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Sell Bribe ($)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="0.01"
            value={sellBribe}
            onChange={(e) => setSellBribe(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Vzjatka dlja uvelicenija prioriteta pri prodaze
          </span>
        </div>


  {/* Sell Slippage */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Sell Slippage (%)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="1"
            value={sellSlippage}
            onChange={(e) => setSellSlippage(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Dopustimoe otklonenie ceni pri prodaze (%)
          </span>
        </div>

  {/* Max Sell Tax */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Max Sell Tax (%)</label>
          <input
            type="text" inputMode="decimal"
            placeholder="5"
            value={maxSellTax}
            onChange={(e) => setMaxSellTax(e.target.value)}
            style={{
              width: '100%',
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #374151',
              backgroundColor: '#111827',
              color: '#d1d5ab',
            }}
          />
          <span style={{ fontSize: '12px', color: '#6b7280' }}>
            Maksimalnij razreshonnij nalog pri prodaze (%)
          </span>
        </div>


  {/* Anti Mev Sell */}
        <div style={{ marginTop: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px' }}>Anti Mev Sell</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="checkbox"
              checked={antiMevSell}
              onChange={(e) => setAntiMevSell(e.target.checked)}
            />
            <span style={{ color: '#9ca3af' }}>
              Vkljucitj zaschitu ot Mev atak pri prodaze
            </span>
          </div>
        </div>
 

  {/* Knopka Sohranitj */}

        <button
          onClick={() => {
            if (!manualEnabled && buyAllEnabled && buyAmountEnabled) {
              alert("Oshibka: Mozhno ukazatj tolko odin variant — Buy All ILI Buy Amount.");
              return;
            }

            if (!manualEnabled && !buyAllEnabled && !buyAmountEnabled) {
              alert("Oshibka: Ne ukazan sposob pokupki — Buy All ILI Buy Amount.");
              return;
            }

            if ((manualEnabled && !autoSell) || (!manualEnabled && !autoSell && !copySell)) {
              alert("Oshibka: Zapolnite Auto sell ili Copy sell.");
              return;
            }

          const payload = {
            walletName,
            walletAddress,
                settings: {
                  manualEnabled,
                  traderAddress: manualEnabled ? "" : traderAddress,
                  solanaNetwork,
                  activeDexes: [
                    "Jupiter", "Dexscreener", "Raydium", "Orca", "Saber" 
                  ],
                  honeypotCheck,
                  honeypotMode,
                  freezeCheck,
                  buyAllEnabled: manualEnabled ? false : buyAllEnabled,
                  buyAmount: manualEnabled ? null : (buyAmountEnabled ? buyAmount : null),
                  reserveAmount,
                  buyTimes,
                  slippage,
                  liquidity,
                  priorityFeeUsd: priorityFee,
                  bribe,
                  maxTax,
                  minVolume24h,
                  antiMevBuy,
                  autoSell,
                  copySell: manualEnabled ? false : copySell,
                  enableTakeProfit,
                  takeProfitPercent: enableTakeProfit ? takeProfitPercent : "",
                  enableStopLoss,
                  stopLossPercent: enableStopLoss ? stopLossPercent : "",
                  trailingStop: { enabled: enableTrailingStop, percent: enableTrailingStop ? trailingStopPercent : "" },
                  sellPriorityFee,
                  sellBribe,
                  sellSlippage,
                  maxSellTax,
                  antiMevSell
                },
                ...(privateKey ? { privateKey: JSON.parse(privateKey) } : {})
              };

            fetch('/api/wallets/save', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(payload),
            })
              .then(async (res) => {
                const  contentType = res.headers.get("content-type");

                if (!res.ok) {
                  let msg = 'Oshibka pri sohranenii';
                if (contentType && contentType.includes("application/json")) {

                  const data = await res.json();
                  msg = data.error || msg;
                } else {
                  msg = await res.text();
                }
                alert(msg);
                return;
              }

              const data = await res.json();
              if (data?.success) {
                if (data.updated) {
                  alert('Fail koselka obnovljon!');
                } else {
                  alert('Koseljok sohranjon');
                }
              }
            })
            .catch(err => {
              console.error('Setevaja oshibka:', err);
              alert('Setevaja oshibka pri soedenenii s serverom');
            });
          }}
          style={{
            margin: '30px auto 0',
            padding: '12px 20px',
            backgroundColor: '#facc15',
            color: '#1f2937',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '16px',
            cursor: 'pointer',
            width: '30%'
          }}
        >
          Sohranitj
        </button>

        </div>

  {/* Knopka zakritija okna */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            background: 'transparent',
            border: 'none',
            color: '#aaa',
            fontSize: '20px',
            cursor: 'pointer'
          }}
        >

          x

        </button>
      </div>
    </div>
  );
}


export default SettingsModal;
